/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Files_Error_Causes_RetryingInputs */



/**
* | output |
* | --- |
* | "Retrying…" |
*
* @param {Files_Error_Causes_RetryingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const files_error_causes_retrying = /** @type {((inputs?: Files_Error_Causes_RetryingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Files_Error_Causes_RetryingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird wiederholt…")
	return /** @type {LocalizedString} */ ("Retrying…")
});